// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iFwi","content":"styles_content__31Hs1"};